import { call, put, select } from 'redux-saga/effects';
import { signalingChatReactionToggled } from 'features/chat/actions';
import { messageReactionsSet, selectMessageReactions } from 'features/chat/chatSlice';
import { GroupedReaction } from 'features/chat/types';
import { computeReactions } from 'features/chat/utils/computeReactions';

export function* onChatReactionToggledSaga(
  action: ReturnType<typeof signalingChatReactionToggled>
) {
  const {
    data: { messageId, emoji, added, local },
    initiator,
  } = action.payload;

  const currentReactions: GroupedReaction[] = yield select(selectMessageReactions, messageId);
  const reactions: GroupedReaction[] = yield call(
    computeReactions,
    currentReactions,
    emoji,
    {
      ...initiator,
      id: initiator.externalId || initiator.id,
      userId: initiator.id,
      local,
    },
    added,
    local
  );

  yield put(messageReactionsSet({ messageId, reactions }));
}
